// import React, { useEffect, useState } from "react";
// import { Formik, Field, Form, FormikConsumer } from "formik";
// import * as Yup from "yup";
// import {
//   TextField,
//   RadioGroup,
//   Radio,
//   FormControlLabel,
//   Button,
//   Grid,
//   Box,
//   CircularProgress,
// } from "@mui/material";
// import { Typography } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import { api } from "../../../axios/api";
// import { useSelector } from "react-redux";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import AES from "crypto-js/aes";

// const validationSchema = Yup.object().shape({
//   name: Yup.string().required("Required"),
//   email: Yup.string().required("Required"),
//   // password: Yup.string().required("Required"),
//   phone_number: Yup.string().required("Required"),
// });

// const AddUserForm = ({ editOptions, setShowAddForm }) => {
//   const [loading, setLoading] = useState(false);
//   const theme = useTheme();
//   const user = useSelector((state) => state.user);
//   const [authorizedToCompany, setAuthorizedToCompany] = useState(true);
//   const [authorizedToCompanyError, setAuthorizedToCompanyError] = useState("");

//   const [initialValues, setInitialValues] = useState(
//     editOptions
//       ? {
//           name: editOptions?.name,
//           email: editOptions?.email_address,
//           password: "",
//           phone_number: editOptions?.phone_number,
//           profile_type: "employee",
//           authorized_to_company_details:
//             editOptions?.authorized_to_company_details,
//         }
//       : {
//           name: "",
//           email: "",
//           password: "",
//           phone_number: "",
//           profile_type: "employee",
//           authorized_to_company_details: "true",
//         }
//   );

//   useEffect(() => {
//     console.log("user at add contact", user);
//   }, [user]);
//   useEffect(() => {
//     console.log("edit options at add supplier form", editOptions);
//     setAuthorizedToCompany(editOptions?.authorized_to_company_details);
//   }, [editOptions]);
//   useEffect(() => {
//     setAuthorizedToCompanyError("");
//   }, [authorizedToCompany]);
//   useEffect(() => {
//     console.log("authorizedToCompanyError", authorizedToCompanyError);
//   }, [authorizedToCompanyError]);
//   const onSubmit = (values, { resetForm }) => {
//     console.log("running on submit");
//     setLoading(true);
//     console.log(values);
//     console.log("authorizedToCompany", authorizedToCompany);
//     console.log("authorizedToCompanyError", authorizedToCompanyError);
//     if (!authorizedToCompany) {
//       console.log("error occur");
//       setAuthorizedToCompanyError("select one");
//       setLoading(false);
//       return;
//     }
//     var encPass = AES.encrypt(
//       values.password,
//       process.env.REACT_APP_CRYPTO_JS_KEY
//     ).toString();

//     // return;
//     if (editOptions?.id) {
//       let body = {
//         name: values.name,
//         email_address: values.email,
//         phone_number: values.phone_number,
//         authorized_to_company_details: authorizedToCompany,
//       };
//       if (showResetPassword) {
//         body = { ...body, password: encPass };
//       }
//       api
//         .put("/updateUserByAdmin/" + editOptions?.id, body)
//         .then((res) => {
//           console.log("response from posting content", res?.data);
//           toast.success("user updated successfully!");
//           setShowAddForm(false);
//           setLoading(false);
//           resetForm();
//         })
//         .catch((err) => {
//           console.log("err", err);
//           setLoading(false);
//           toast.error("error in adding contact");
//         });
//     } else {
//       let body = {
//         name: values.name,
//         email_address: values.email,
//         password: encPass,
//         phone_number: values.phone_number,
//         profile_type: values.profile_type,
//         authorized_to_company_details: authorizedToCompany,
//       };
//       api
//         .post("/addUserByAdmin", body)
//         .then((res) => {
//           console.log("response from posting content", res?.data);
//           toast.success("contact added successfully!");
//           resetForm();
//           setLoading(false);
//           setTimeout(() => {
//             setShowAddForm(false);
//           }, 2000);
//         })
//         .catch((err) => {
//           if (err?.response?.status == 409)
//             toast.error("Email already registered in our system");
//           else toast.error("error in adding contact");
//           setLoading(false);
//         });
//     }
//   };
//   const cancelForm = () => {
//     setShowAddForm(false);
//   };
//   const [showResetPassword, setShowResetPassword] = useState(false);
//   return (
//     <Box sx={{ padding: "30px 0px" }}>
//       <ToastContainer />
//       {/* <Typography
//         variant="h6"
//         sx={{
//           color: theme.palette.heading.main,
//           fontSize: "1.3rem",
//           fontWeight: "600",
//         }}
//       >
//         Add Contact
//       </Typography> */}
//       <Box
//         sx={{
//           backgroundColor: theme.palette.background.main,
//           padding: "20px",
//           borderRadius: "5px",
//           marginTop: "20px",
//           maxWidth: "700px",
//         }}
//       >
//         <Typography
//           variant="body2"
//           sx={{ margin: "10px 0 30px 0", color: theme.palette.para.main }}
//         >
//           Fill up the form with user data.
//         </Typography>
//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={onSubmit}
//         >
//           {({ errors, touched }) => (
//             <Form>
//               <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                   <Field
//                     name="name"
//                     as={TextField}
//                     label="Name"
//                     fullWidth
//                     error={touched.name && Boolean(errors.name)}
//                     helperText={touched.name && errors.name}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={editOptions?.id ? 12 : 6}>
//                   <Field
//                     disabled={editOptions?.id}
//                     name="email"
//                     as={TextField}
//                     label="Email"
//                     fullWidth
//                     error={touched.email && Boolean(errors.email)}
//                     helperText={touched.email && errors.email}
//                   />
//                 </Grid>
//                 {editOptions?.id && !showResetPassword && (
//                   <Grid item xs={12} sm={editOptions?.id ? 12 : 6}>
//                     <Button onClick={() => setShowResetPassword(true)}>
//                       Reset Password
//                     </Button>
//                   </Grid>
//                 )}
//                 {(!editOptions?.id || showResetPassword) && (
//                   <Grid item xs={12} sm={6}>
//                     <Field
//                       name="password"
//                       as={TextField}
//                       label="Password"
//                       fullWidth
//                       error={touched.password && Boolean(errors.password)}
//                       helperText={touched.password && errors.password}
//                     />
//                   </Grid>
//                 )}

//                 <Grid item xs={12}>
//                   <Field
//                     name="phone_number"
//                     as={TextField}
//                     label="Phone Number"
//                     fullWidth
//                     error={touched.phone_number && Boolean(errors.phone_number)}
//                     helperText={touched.phone_number && errors.phone_number}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography
//                     variant="p"
//                     sx={{ color: theme.palette.heading.main }}
//                   >
//                     Authorize to view company's performance dashboard
//                   </Typography>
//                   <FormikConsumer>
//                     {({ values }) => (
//                       <RadioGroup
//                         name="authorized_to_company_details"
//                         value={authorizedToCompany}
//                         onChange={(event) =>
//                           setAuthorizedToCompany(event.target.value)
//                         }
//                         row
//                       >
//                         <FormControlLabel
//                           value={true}
//                           control={<Radio />}
//                           label="Yes"
//                           defaultChecked={
//                             values.authorized_to_company_details == "true"
//                           }
//                         />
//                         <FormControlLabel
//                           value={false}
//                           control={<Radio />}
//                           label="No"
//                           defaultChecked={
//                             values.authorized_to_company_details == "false"
//                           }
//                         />
//                       </RadioGroup>
//                     )}
//                   </FormikConsumer>
//                   {authorizedToCompanyError && (
//                     <Typography variant="body2" sx={{ color: "red" }}>
//                       {authorizedToCompanyError}
//                     </Typography>
//                   )}
//                 </Grid>

//                 <Grid item xs={12} sm={4}></Grid>
//                 <Grid item xs={12} sm={4}></Grid>
//                 {/* <Grid item xs={12}>
//                   <Field name="type">
//                     {({ field }) => (
//                       <RadioGroup {...field} row>
//                         <FormControlLabel
//                           value="supplier"
//                           control={<Radio defaultChecked={true} />}
//                           label="Supplier"
//                         />
//                         <FormControlLabel
//                           value="consignee"
//                           control={<Radio />}
//                           label="Consignee"
//                         />
//                       </RadioGroup>
//                     )}
//                   </Field>
//                 </Grid> */}
//                 <Grid item xs={12}>
//                   {" "}
//                   {loading && <CircularProgress sx={{}} />}
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Button
//                     variant="contained"
//                     // color={theme.palette.colortwo.main}
//                     sx={{
//                       backgroundColor: theme.palette.colortwo.main,
//                       color: theme.palette.whiteFont.main,
//                     }}
//                     type="submit"
//                     size="small"
//                   >
//                     {editOptions?.id ? "Update" : "Submit"}
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={() => cancelForm()}
//                     sx={{
//                       marginLeft: "10px",
//                       backgroundColor: theme.palette.colortwo.main,
//                       color: theme.palette.whiteFont.main,
//                     }}
//                     size="small"
//                   >
//                     Cancel
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Form>
//           )}
//         </Formik>
//       </Box>
//     </Box>
//   );
// };

// export default AddUserForm;
import React, { useEffect, useState } from "react";
import {
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  Grid,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AES from "crypto-js/aes";
import { api } from "../../../axios/api";

const AddUserForm = ({ editOptions, setShowAddForm }) => {
  const theme = useTheme();
  const user = useSelector((state) => state.user);

  // form state
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    phone_number: "",
    profile_type: "employee",
  });
  const [authorizedToCompany, setAuthorizedToCompany] = useState(true);

  // validation state
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [authorizedError, setAuthorizedError] = useState("");

  const [loading, setLoading] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);

  // initialize on edit
  useEffect(() => {
    if (editOptions) {
      setValues({
        name: editOptions.name || "",
        email: editOptions.email_address || "",
        password: "",
        phone_number: editOptions.phone_number || "",
        profile_type: editOptions.profile_type || "employee",
      });
      setAuthorizedToCompany(!!editOptions.authorized_to_company_details);
    }
  }, [editOptions]);

  // clear auth error when user toggles
  useEffect(() => {
    setAuthorizedError("");
  }, [authorizedToCompany]);

  // simple required-field validation
  const validate = () => {
    const newErrors = {};
    if (!values.name.trim()) newErrors.name = "Required";
    if (!values.email.trim()) newErrors.email = "Required";
    if ((!editOptions?.id || showResetPassword) && !values.password)
      newErrors.password = "Required";
    if (!values.phone_number.trim()) newErrors.phone_number = "Required";
    return newErrors;
  };

  const handleChange = (field) => (e) => {
    const val = e.target.value;
    setValues((v) => ({ ...v, [field]: val }));
  };

  const handleBlur = (field) => () => {
    setTouched((t) => ({ ...t, [field]: true }));
    setErrors(validate());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    setTouched({
      name: true,
      email: true,
      password: true,
      phone_number: true,
    });

    // check authorizedToCompany (must be true)
    if (!authorizedToCompany) {
      setAuthorizedError("Select yes to authorize");
      // return;
    }

    if (Object.keys(newErrors).length) return;

    setLoading(true);

    // encrypt if needed
    let encPass = "";
    if (!editOptions?.id || showResetPassword) {
      encPass = AES.encrypt(
        values.password,
        process.env.REACT_APP_CRYPTO_JS_KEY
      ).toString();
    }

    try {
      if (editOptions?.id) {
        // update flow
        const body = {
          name: values.name,
          email_address: values.email?.toLowerCase(),
          phone_number: values.phone_number,
          authorized_to_company_details: authorizedToCompany,
          ...(showResetPassword && { password: encPass }),
        };
        await api.put(`/updateUserByAdmin/${editOptions.id}`, body);
        toast.success("User updated successfully!");
      } else {
        // create flow
        const body = {
          name: values.name,
          email_address: values.email?.toLowerCase(),
          password: encPass,
          phone_number: values.phone_number,
          profile_type: values.profile_type,
          authorized_to_company_details: authorizedToCompany,
        };
        await api.post("/addUserByAdmin", body);
        toast.success("Contact added successfully!");
      }
      setShowAddForm(false);
    } catch (err) {
      if (err?.response?.status === 409) {
        toast.error("Email already registered in our system");
      } else {
        toast.error("Error in adding contact");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: "30px 0" }}>
      <ToastContainer />
      <Box
        sx={{
          bgcolor: theme.palette.background.main,
          p: 2,
          borderRadius: 1,
          mt: 2,
          maxWidth: 700,
        }}
      >
        <Typography
          variant="body2"
          sx={{ mb: 3, color: theme.palette.para.main }}
        >
          Fill up the form with user data.
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* Name */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                value={values.name}
                onChange={handleChange("name")}
                onBlur={handleBlur("name")}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12} sm={editOptions?.id ? 12 : 6}>
              <TextField
                fullWidth
                label="Email"
                disabled={!!editOptions?.id}
                value={values.email}
                onChange={handleChange("email")}
                onBlur={handleBlur("email")}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
              />
            </Grid>

            {/* Reset Password button */}
            {editOptions?.id && !showResetPassword && (
              <Grid item xs={12} sm={12}>
                <Button onClick={() => setShowResetPassword(true)}>
                  Reset Password
                </Button>
              </Grid>
            )}

            {/* Password */}
            {(!editOptions?.id || showResetPassword) && (
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="password"
                  label="Password"
                  value={values.password}
                  onChange={handleChange("password")}
                  onBlur={handleBlur("password")}
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                />
              </Grid>
            )}

            {/* Phone */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                value={values.phone_number}
                onChange={handleChange("phone_number")}
                onBlur={handleBlur("phone_number")}
                error={touched.phone_number && Boolean(errors.phone_number)}
                helperText={touched.phone_number && errors.phone_number}
              />
            </Grid>

            {/* Authorization */}
            <Grid item xs={12}>
              <Typography sx={{ color: theme.palette.heading.main }}>
                Authorize to view company&#39;s performance dashboard
              </Typography>
              <RadioGroup
                row
                value={authorizedToCompany.toString()}
                onChange={(e) =>
                  setAuthorizedToCompany(e.target.value === "true")
                }
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              {authorizedError && (
                <Typography variant="body2" color="error">
                  {authorizedError}
                </Typography>
              )}
            </Grid>

            {/* Loading indicator */}
            {loading && (
              <Grid item xs={12}>
                <CircularProgress />
              </Grid>
            )}

            {/* Submit & Cancel */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: theme.palette.colortwo.main,
                  color: "#f2eee6",
                }}
                size="small"
              >
                {editOptions?.id ? "Update" : "Submit"}
              </Button>
              <Button
                onClick={() => setShowAddForm(false)}
                variant="contained"
                sx={{
                  ml: 1,
                  bgcolor: theme.palette.colortwo.main,
                  color: "#f2eee6",
                }}
                size="small"
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default AddUserForm;
